// @ts-nocheck
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { TriggerCoachImportTestEmails } from '@/components/admin/TriggerCoachImportTestEmails';

const TestNotificationsPage = () => {
  const { user, profile } = useAuth();

  if (!user || profile?.role !== 'admin') {
    return (
      <div className="p-4 bg-red-100 border-l-4 border-red-500 text-red-700">
        <p className="font-bold">Access Denied</p>
        <p>You don't have permission to access this page.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="mb-6">
        <h1 className="text-3xl font-heading font-bold">Test Notifications</h1>
        <p className="text-muted-foreground">Debug and test the notification system</p>
      </div>

      <div className="space-y-6">
        <TriggerCoachImportTestEmails />
      </div>
    </div>
  );
};

export default TestNotificationsPage;
